<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="评价月" prop="monthList">
                    <el-select v-model="queryCondition.monthList" clearable multiple placeholder="请选择(支持多选)" style="width:100%" class="multiple_sel">
                      <el-option :key="index" v-for="(item,index) in monthOptions" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="QIP单据编号" prop="qipCode">
                    <el-input v-model="queryCondition.qipCode" clearable placeholder="支持模糊查询" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="DC编号" prop="dcCodeList">
                    <el-select v-model="queryCondition.dcCodeList" clearable multiple placeholder="请选择" style="width:100%" class="multiple_sel">
                      <el-option :key="index" v-for="(item,index) in dcCodeListOptions" :label="item.dcCode" :value="item.dcCode"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="供应商名称" prop="supplierName">
                    <el-input v-model="queryCondition.supplierName" clearable placeholder="支持模糊查询" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="产品名称" prop="eightBitCodeName">
                      <el-input v-model="queryCondition.eightBitCodeName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="产品类别" prop="category2CodeList">
                      <el-select v-model="queryCondition.category2CodeList" multiple clearable placeholder="请选择" style="width:100%" class="multiple_sel">
                        <el-option :key="index" v-for="(item,index) in category2CodeOptions" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="不合格原因" prop="causeOfNonconformityList">
                      <ic-select v-model="queryCondition.causeOfNonconformityList" table="TT_QSPI_QIP" field="CAUSE_OF_NONCONFORMITY" multiple clearable placeholder="请选择" style="width:100%" class="multiple_sel"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="风险等级" prop="riskGrade">
                      <ic-select v-model="queryCondition.riskGrade" table="TT_QSPI_QIP" field="RISK_GRADE" clearable placeholder="请选择" style="width:100%" class="multiple_sel"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="问题产品数量">
                      <el-row type="flex" align="middle" justify="space-between">
                        <el-col :span="10">
                          <el-input v-model="queryCondition.minQuantity" clearable style="width:100%"></el-input>
                        </el-col>
                        <el-col :span="2" style="text-align:center">
                          <p style="height:1px;background:#000;text-align:center"></p>
                        </el-col>
                        <el-col :span="10">
                          <el-input v-model="queryCondition.maxQuantity" clearable style="width:100%"></el-input>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="单位" prop="mcdBuyingUnit">
                      <ic-select clearable table="TM_MATERIAL_RECORD" field="MCD_BUYING_UNIT" v-model="queryCondition.mcdBuyingUnit" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="责任方" prop="responsiblePartyList">
                      <ic-select v-model="queryCondition.responsiblePartyList" table="TT_QSPI_QIP" field="RESPONSIBLE_PARTY" placeholder="请选择" multiple clearable style="width:100%" class="multiple_sel"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="承运商" prop="carrierCode">
                      <el-select v-model="queryCondition.carrierCode" clearable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in carrierCodeOptions" :label="item.supplierName" :value="item.supplierCode"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="反馈结果" prop="feedbackResults">
                      <el-select v-model="queryCondition.feedbackResults" clearable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in feedbackResultsOptions" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="状态" prop="statusList">
                      <ic-select v-model="queryCondition.statusList" table="TT_QSPI_QIP" field="STATUS" :excludes="excludesValue" placeholder="请选择" clearable multiple style="width:100%" class="multiple_sel"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="FSC反馈状态" prop="fscFeedbackStatus">
                      <ic-select v-model="queryCondition.fscFeedbackStatus" table="TT_QSPI_QIP" field="FSC_FEEDBACK_STATUS" :excludes="excludesValue" placeholder="请选择" clearable style="width:100%" class="multiple_sel"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" v-if="ms_emplFlag!=='SUP'">
                    <el-form-item label="责任方是否已确定" prop="responsibleConfirm">
                      <ic-select v-model="queryCondition.responsibleConfirm" table="TT_QSPI_QIP" field="RESPONSIBLE_CONFIRM" :excludes="excludesValue" placeholder="请选择" clearable style="width:100%" class="multiple_sel"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onAdd" v-acl="QSPI_QIP_ADD" v-if="ms_roles.indexOf('QSPI_QIP_DC_QS')!== -1">新增</el-button>
        <el-button size="mini" class="btn" type="danger" @click="onDel" v-acl="QSPI_QIP_DEL" v-if="ms_roles.indexOf('QSPI_QIP_DC_QS')!== -1">删除</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onSubmit" v-acl="QSPI_QIP_SUBMIT" v-if="ms_roles.indexOf('QSPI_QIP_DC_QS')!== -1">提交</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onBatchUpload" v-acl="QSPI_QIP_IMPORT">批量导入</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onExport" v-acl="QSPI_QIP_EXPORT">导出</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onIssue" v-acl="QSPI_QIP_RELEASE" v-if="ms_roles.indexOf('QSPI_QIP_OWNER')!== -1">下发</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onVerificationCompleted" v-acl="QSPI_QIP_CHECKED" v-if="ms_roles.indexOf('QSPI_QIP_OWNER')!== -1">核实完成</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onBatchModify" v-acl="QSPI_QIP_BATCH_SAVE" v-if="ms_roles.indexOf('QSPI_QIP_OWNER')!== -1">批量修改</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onVoid" v-acl="QSPI_QIP_INVALID" v-if="ms_roles.indexOf('QSPI_QIP_OWNER')!== -1">作废</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onNoObjection" v-acl="QSPI_QIP_SUPPLIER,QSPI_QIP_CARRIER">无异议(支持多选)</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onObjection" v-acl="QSPI_QIP_SUPPLIER,QSPI_QIP_CARRIER">有异议</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onCreatGrade" v-acl="QSPI_QIP_GEN_TASK">生成月度等级</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onReject('Y')" v-if="ms_Permission.indexOf('QSPI_QIP_CONRECP') > -1">条件收货</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onReject('N')" v-if="ms_Permission.indexOf('QSPI_QIP_REJRECP') > -1">拒收</el-button>
        <el-button size="mini" class="btn" type="primary" v-if="isAssistedDecision" @click="onCqsConfirm">邀请CQS协助判定</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" :checkboxConfig="{checkMethod: selectable, highlight: true}" @cell-click="cellClick" :cell-class-name='setCellClass' max-height="600" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="评价月" resizable min-width="100" field="month"></ux-table-column>
        <ux-table-column align="center" title="QIP单据编号" resizable min-width="120" field="qipCode">
          <template v-slot="{ row }">
            <el-button type="text" @click="onDetail(row)">{{row.qipCode}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="供应商名称" resizable min-width="160" field="supplierName"></ux-table-column>
        <ux-table-column align="center" title="Facility名称" resizable min-width="160" field="facilityName"></ux-table-column>
        <ux-table-column align="center" title="产品名称" resizable min-width="160" field="eightBitCodeName"></ux-table-column>
        <ux-table-column align="center" title="产品类别" resizable min-width="90" field="category2Name"></ux-table-column>
        <ux-table-column align="center" title="不合格原因" resizable min-width="160" field="causeOfNonconformityI18n"></ux-table-column>
        <ux-table-column align="center" title="风险等级" resizable min-width="100" field="riskGrade"></ux-table-column>
        <ux-table-column align="center" title="问题产品数量" resizable min-width="100" field="quantity"></ux-table-column>
        <ux-table-column align="center" title="单位" resizable min-width="120" field="mcdBuyingUnitI18n"></ux-table-column>
        <ux-table-column align="center" title="责任方" resizable min-width="90" field="responsibleParty"></ux-table-column>
        <ux-table-column align="center" title="承运商" resizable min-width="90" field="carrierName"></ux-table-column>
        <ux-table-column align="center" title="QIP日期" resizable min-width="120" field="qipDate"></ux-table-column>
        <ux-table-column align="center" title="产品生产日期" resizable min-width="130" field="productionDate"></ux-table-column>
        <ux-table-column align="center" title="产品编号" resizable min-width="90" field="eightBitCode"></ux-table-column>
        <ux-table-column align="center" title="发现环节" resizable min-width="120" field="discoveryLinkI18n"></ux-table-column>
        <ux-table-column align="center" title="处理方式" resizable min-width="120" field="processingModeI18n"></ux-table-column>
        <ux-table-column align="center" title="备注" resizable min-width="150" field="remarks"></ux-table-column>
        <ux-table-column align="center" title="QIP_Owner备注" resizable min-width="150" field="ownerRemarks" v-if="ms_roles.indexOf('QSPI_QIP_OWNER')!== -1"></ux-table-column>
        <ux-table-column align="center" title="状态" resizable min-width="90" field="statusI18n"></ux-table-column>
        <ux-table-column align="center" title="反馈结果" resizable min-width="120" field="feedbackResults"></ux-table-column>
        <ux-table-column align="center" title="FSC反馈状态" resizable min-width="120" field="fscFeedbackStatusI18n"></ux-table-column>
        <ux-table-column align="center" title="责任方是否已确定" resizable min-width="120" field="responsibleConfirmI18n" v-if="ms_emplFlag!=='SUP'"></ux-table-column>
        <ux-table-column align="center" title="更新人" resizable min-width="120" field="updateName"></ux-table-column>
        <ux-table-column align="center" title="更新时间" resizable min-width="90" field="updateDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="维护异议" :visible.sync="dialogObjectVisible" width="40%" @close="onCloseObject" :close-on-click-modal="false">
      <feedback-Dialog v-if="dialogObjectVisible" :userId="userId" :idList="idList" :proposeResponsibleParty="proposeResponsibleParty" @onCloseObject="onCloseObject"></feedback-Dialog>
    </el-dialog>
    <el-dialog title="批量修改" :visible.sync="dialogBatchVisible" width="40%" @close="onClose" :close-on-click-modal="false">
      <modify-Dialog v-if="dialogBatchVisible" :idList="idList" @onClose="onClose"></modify-Dialog>
    </el-dialog>
    <!-- 条件收货或拒收Dialog -->
    <el-dialog :title="dialogTit === 'Y' ? '条件收货' : ( dialogTit === 'N' ? '拒收' : '邀请CQS协助判定')" :visible.sync="dialogReVisable" width="40%" @close="onCloseReject" :close-on-click-modal="false">
      <reject-dialog v-if="dialogReVisable" :idList="idList" :dialogTit="dialogTit" @onCloseReject="onCloseReject"></reject-dialog>
    </el-dialog>
    <el-dialog title="批量导入" :visible.sync="dialogBatchUploadVisible" width="40%" :close-on-click-modal="false" @close="onClose1">
      <el-row style="margin-bottom:10px">
        <el-upload ref="batchUpload" :headers="header" :action="uploadUrl" :on-success="uploadSuccess" :on-change="handleChange" :before-upload="beforeUpload" :file-list="fileList" :auto-upload="false" :show-file-list="false" style="display:inline-block;margin-right:10px">
          <el-button size="small" type="primary">选取文件</el-button>
        </el-upload>
        <el-button size="small" class="btn" type="primary" @click="qipTemplateDownload">模板下载</el-button>
      </el-row>
      <el-form :model="uploadForm" ref="uploadForm">
        <el-form-item>
          <el-input v-model="uploadForm.fileName" readonly></el-input>
        </el-form-item>
      </el-form>
      <el-row>
        <h4>说明:</h4>
        <ul>
          <li>1.请点击模板下载,按照模板填写后再上传</li>
          <li>2.模板中红色字段为必填项,请务必正确填写</li>
          <li>3.仅支持上传Excel格式文件,且大小不能超过20M</li>
          <li>4.为保证上传成功,请勿对模板中的单元格进行修改</li>
          <li>5.一次仅支持一份文件上传,多份文件上传将会替换原文件</li>
        </ul>
      </el-row>
      <el-row type="flex" justify="center">
        <el-button size="mini" class="btn" type="primary" @click="onUpload">上传</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onClose1">关闭</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import store from '@/store/index'
import IcSelect from "@/components/common/icSelect";
import DQMPApi from "@/api/DQMP/index";
import QIPApi from "@/api/QIP/index";
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";
import feedbackDialog from "./feedbackDialog.vue";
import modifyDialog from "./modifyDialog.vue";
import rejectDialog from "./rejectDialog.vue";
import { fileService } from "@/api/common/file-utils";
import { Loading, Message } from "element-ui";
export default {
  name: 'QIP',
  mixins: [paginationMixin],
  components: {
    IcSelect,
    feedbackDialog,
    modifyDialog,
    rejectDialog
  },
  data() {
    return {
      multipleSelection: [],
      monthOptions: [],
      category2CodeOptions: [],
      carrierCodeOptions: [],
      feedbackResultsOptions: [
        {
          label: "有异议",
          value: "有异议",
        },
        {
          label: "无异议",
          value: "无异议",
        },
        {
          label: "已超时",
          value: "已超时",
        }
      ],
      dialogTit: "", //条件收货和拒收标题
      dialogReVisable: false, //显示条件收货和拒收弹框
      dcCodeListOptions: [],
      tableData: [],
      idList: [],
      multipleSelection: [],
      fileList: [],
      excludesValue: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        monthList: [],
        qipCode: "",
        supplierName: "",
        eightBitCodeName: "",
        category2CodeList: [],
        causeOfNonconformityList: [],
        minQuantity: "",
        maxQuantity: "",
        mcdBuyingUnit: "",
        responsiblePartyList: [],
        carrierCode: "",
        feedbackResults: "",
        statusList: [],
        fscFeedbackStatus: "",
        dcCodeList: [],
        riskGrade: ""
      },
      uploadForm: {
        fileName: "",
      },
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      isShow: false,
      dialogObjectVisible: false,
      dialogBatchVisible: false,
      dialogBatchUploadVisible: false,
      totalCount: 0,
      pages: 1,
      ms_roles: null,
      ms_userId: null,
      proposeResponsibleParty: null,
      ms_Permission: null,
      userId: null,
      isAssistedDecision: false,
      ms_roles: null,
      ms_emplFlag: null,
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  computed: {
    uploadUrl() {
      return process.env.VUE_APP_SERVER_BASE_URL + `/qspiQip/qipImportExcel`;
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/qspiTodo' && to.query.month) {
      to.meta.reqData.monthList = []
      to.meta.reqData.monthList.push(to.query.month);
    }
    if (from.path === '/qspiTodo' && to.query.status) {
      to.meta.reqData.statusList = []
      to.meta.reqData.statusList = JSON.parse(to.query.status)
    }
    if (from.path === '/qspiTodo' && to.query.code) {
      to.meta.reqData.qipCode = ""
      to.meta.reqData.qipCode = to.query.code
      to.meta.reqData.fscFeedbackStatus = ""
      to.meta.reqData.fscFeedbackStatus = to.query.fscType
    }
    if (from.path === '/qspiTodo' && to.query.cqsType) {
      to.meta.reqData.fscFeedbackStatus = ""
      to.meta.reqData.fscFeedbackStatus = to.query.cqsType
      to.meta.reqData.category2CodeList = []
      to.meta.reqData.category2CodeList = [to.query.category2]
    }
    // category2
    QIPApi.findListPage(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.data.records;
        vm.totalCount = res.data.total;
      })
    })
  },
  created() {
    this.ms_userId = JSON.parse(localStorage.getItem('ms_userId'))
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'))
    this.ms_roles = JSON.parse(localStorage.getItem('ms_roles'))
    this.ms_emplFlag = localStorage.getItem('ms_emplFlag')
    console.log("this.ms_Permission.indexOf('QSPI_QIP_SUBMIT') < 0", this.ms_Permission.indexOf('QSPI_QIP_SUBMIT') < 0);
    if (this.ms_Permission.indexOf('QSPI_QIP_SUBMIT') < 0) {
      this.excludesValue.push('DRAFT')
      if (this.ms_Permission.indexOf('QSPI_QIP_RELEASE') < 0 && this.ms_Permission.indexOf('QSPI_QIP_CONRECP') < 0) {
        this.excludesValue.push('SUBMITTED', 'CANCEL')
      }
    }
    if (this.ms_Permission.indexOf('QSPI_QIP_INVOLVECQS') !== -1) {
      this.isAssistedDecision = true;
    } else {
      this.isAssistedDecision = false;
    }
    // 是否显示邀请cqs判定
    this.getQspiDcList()
    this.getMonth();
    this.getCarrier();
    this.getCategory();
  },
  methods: {
    queryData() {
      QIPApi.findListPage(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
        this.pages = res.data.pages;
        this.$refs.plxTable.reloadData(res.data.records)
      });
    },
    getQspiDcList() {
      QIPApi.getQspiDcList({
        status: "ACTIVE",
        pageSize: -1,
      }).then(res => {
        console.log('res', res);
        this.dcCodeListOptions = res.resultData
      })
    },
    qipTemplateDownload() {
      QIPApi.qipTemplateDownload().then(res => {
        fileService.respToFile(res, 'QIP模板.xlsx');
      });
    },
    onBatchUpload() {
      this.dialogBatchUploadVisible = true
    },
    beforeUpload(file) {
      console.log('beforeUpload', file);
      var isExcel = true
      if (file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type == "application/vnd.ms-excel") {
        isExcel = true
      } else {
        isExcel = false
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isExcel) {
        this.$my_message('请选择Excel文件上传', 'error');
      }
      if (!isLt50M) {
        this.$my_message('附件大小不得超过50M', 'error');
      }
      return isExcel && isLt50M;
    },
    handleChange(file, fileList) {
      console.log('file', file);
      console.log('fileList', fileList);
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
      }
      this.uploadForm.fileName = file.name
    },
    onUpload() {
      this.$refs.batchUpload.submit();
    },
    onClose1() {
      this.dialogBatchUploadVisible = false
      this.uploadForm.fileName = ''
      this.fileList = []
    },
    getMonth() {
      DQMPApi.getMonth(true).then(res => {
        this.monthOptions = res
      })
    },
    getCarrier() {
      QIPApi.getCarrier({
        type: "CARRIER",
        pageSize: -1
      }).then(res => {
        console.log('res', res);
        this.carrierCodeOptions = res.resultData
      })
    },
    getCategory() {
      QIPApi.getCategory({
        categoryLevel: 2
      }).then(res => {
        console.log('res', res);
        this.category2CodeOptions = res.data
      })
    },
    selectionChange(val) {
      this.multipleSelection = val;
      this.idList = []
      val.forEach(ele => {
        this.idList.push(ele.ttQspiQipId)
      })
    },
    uploadSuccess(resp) {
      console.log('resp', resp);
      var data = resp.data.split(',')
      console.log('data', data);
      var successNum = Number(data[0].split('{')[1].split(':')[1])
      console.log('successNum', successNum);
      var errorNum = Number(data[1].split('}')[0].split(':')[1])
      console.log('errorNum', errorNum);
      var total = Number(successNum + errorNum)
      this.dialogBatchUploadVisible = false
      this.fileList = []
      this.uploadForm.fileName = ''
      if (resp.meta.code == 200) {
        this.$message.success('您已成功导入数据' + successNum + '条');
        this.queryData(1);
      } else {
        console.log('resp.meta.msg', resp.meta.msg);
        var totalText = '导入文件数据共 ' + total + ' 条'
        var successText = '满足导入条件: ' + successNum + ' 条'
        var errorText = '不满足导入条件: ' + errorNum + ' 条'
        var sumText = '如果存在导入失败的数据,请导出失败原因,修改后再重新上传'
        const wordText = [totalText, successText, errorText, sumText]
        var newArr = []
        const h = this.$createElement;
        for (const i in wordText) {
          newArr.push(h('p', null, wordText[i]))
        }
        this.$confirm('导入结果', {
          title: '导入结果',
          message: h('div', null, newArr),
          showCancelButton: true,
          confirmButtonText: '导出失败原因',
          confirmButtonClass: "confirmButtonClass",
          cancelButtonClass: "cancelButtonClass",
          cancelButtonText: '取消',
          customClass: "uploadBtn",
          type: 'warning'
        }).then(() => {
          let str = new Blob([resp.meta.msg], { type: 'text/plain;charset=utf-8' })
          saveAs(str, '导入失败原因报表.txt')
        }).catch(() => {
          this.$message.info('已取消导出失败原因')
        })
      }
    },
    downloadTxt(fileName, content) {
      console.log('content', content);
      let a = document.createElement('a');
      a.href = 'data:text/plain;charset=utf-8,' + content
      a.download = fileName
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    uploadError(resp) {
      if (undefined != resp.message) {
        let res = JSON.parse(resp.message);
        this.$message.error(res.msg);
      } else {
        this.$message.error("文件上传失败,请检查后重试！");
      }
    },
    onAdd() {
      this.$router.push({
        path: '/qspiQIP/detail',
        query: {
          from: 'add'
        }
      })
    },
    onDel() {
      if (this.idList.length == 0) {
        this.$my_message('请先选择数据后再操作', 'error');
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'DRAFT'
      })
      if (!flag) {
        this.$my_message("已选中的信息不是草稿状态，无法删除！", 'error');
        return false
      }
      var flag1 = this.multipleSelection.every(ele => {
        return ele.createBy == this.ms_userId
      })
      if (!flag1) {
        this.$my_message("仅可删除自己创建的QIP单据", 'error');
        return false
      }
      //您确定要删除所选记录吗？
      this.$confirm('请确认是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        QIPApi.delBatchQip({
          idList: this.idList
        }).then(res => {
          console.log('res', res);
          if (res.meta.code === 200) {
            this.$my_message("删除成功", 'success');
            this.idList = []
            this.$refs['plxTable'].clearSelection()
            this.queryData()
          }
        });
      })
    },
    onSubmit() {
      if (this.idList.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'DRAFT'
      })
      if (!flag) {
        this.$message.warning("页面勾选存在状态不为草稿的单据，无法提交！")
        return false
      }
      var flag1 = this.multipleSelection.every(ele => {
        return ele.createBy == this.ms_userId
      })
      if (!flag1) {
        this.$my_message("仅可提交自己创建的QIP单据", 'error');
        return false
      }
      this.sendReq('SUBMIT')
    },
    onIssue() {
      if (this.idList.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'SUBMITTED'
      })
      if (!flag) {
        this.$message.warning("页面勾选存在状态不为已提交的单据，无法下发！")
        return false
      }
      let issuedFlag = this.multipleSelection.every(ele => {
        return ele.fscFeedbackStatus == 'TO_BE_ISSUED'
      })
      if (!issuedFlag) {
        this.$message.warning("页面勾选存在FSC反馈状态不为待下发的单据，无法下发！")
        return false
      }
      this.sendReq('ISSUE')
    },
    onVerificationCompleted() {
      if (this.idList.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'OBJECTION_HAVE_BEEN_FEEDBACK' || ele.status == 'TIMED_OUT'
      })
      if (!flag) {
        this.$message.warning("页面勾选存在状态不为已反馈异议以及已超时的单据，无法核实完成！")
        return false
      }
      this.sendReq('COMPLETE')
    },
    onBatchModify() {
      if (this.idList.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      this.dialogBatchVisible = true
    },
    onVoid() {
      if (this.idList.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      this.sendReq('CANCEL')
    },
    onNoObjection() {
      if (this.idList.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'CHECK'
      })
      if (!flag) {
        this.$message.warning("页面勾选存在状态不为核实中的单据，无法反馈！")
        return false
      }
      var isValid = this.multipleSelection.every(ele => {
        return !ele.isObjection
      })
      if (!isValid) {
        this.$message.warning("操作无权限，仅可以反馈承运商为自己的数据")
        return false
      }
      this.sendReq('NO_OBJECTION')
    },
    onObjection() {
      if (this.idList.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'CHECK'
      })
      if (!flag) {
        this.$message.warning("页面勾选存在状态不为核实中的单据，无法反馈！")
        return false
      }
      var isValid = this.multipleSelection.every(ele => {
        return !ele.isObjection
      })
      if (!isValid) {
        this.$message.warning("操作无权限，仅可以反馈承运商为自己的数据")
        return false
      }
      this.proposeResponsibleParty = this.multipleSelection[0].proposeResponsibleParty
      this.userId = this.ms_userId
      this.dialogObjectVisible = true
    },
    onCreatGrade() {
      QIPApi.getMonthRiskGrade().then(res => {
        console.log('生成年度等级', res);
        if (res.meta.code === 200) {
          this.$message.success('操作成功')
          this.queryData()
        }
      });
    },
    // 条件收货  -- 拒收
    onReject(val) {
      if (this.idList.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      let valueStr = val === 'Y' ? "条件收货" : "拒收";
      // dataSource只能是QMS的数据 detailForm.isDcCodeAuth  FSC具有DC_CODE权限
      for (let i = 0; i < this.multipleSelection.length; i++) {
        if (this.multipleSelection[i].dataSource != 'QMS') {
          let errorStr = "页面勾选存在数据来源不是QMS的单据，无法";
          this.$message.warning(errorStr + valueStr)
          return false
        }
        //CQS
        if (this.ms_Permission.indexOf('QSPI_QIP_CONRECP') !== -1 && this.ms_Permission.indexOf('QSPI_QIP_INVOLVECQS') === -1) {
          if (this.multipleSelection[i].fscFeedbackStatus != 'TO_BE_CQS_ISSUED') {
            let errorStr = "页面勾选存在“待FSC反馈状态”不为待CQS反馈的单据，无法";
            this.$message.warning(errorStr + valueStr)
            return false
          }
          //当前CQS是否具有Category权限
          if (!this.multipleSelection[i].isCategoryAuth) {
            let errorStr = "页面勾选存在没有Category操作权限的单据，无法";
            this.$message.warning(errorStr + valueStr)
            return false
          }
        }
        //FSC
        if (this.ms_Permission.indexOf('QSPI_QIP_INVOLVECQS') !== -1) {
          if (this.multipleSelection[i].status != 'SUBMITTED' || this.multipleSelection[i].fscFeedbackStatus != 'TO_BE_FSC_ISSUED') {
            let errorStr = "页面勾选存在“待FSC反馈状态”不为待FSC反馈的单据，无法";
            this.$message.warning(errorStr + valueStr)
            return false
          }
          // 当前FSC是否具有DC权限
          if (!this.multipleSelection[i].isDcCodeAuth) {
            let errorStr = "页面勾选存在没有“DC编号”操作权限的单据，无法";
            this.$message.warning(errorStr + valueStr)
            return false
          }
        }
      }
      this.dialogTit = val;
      this.dialogReVisable = true;
    },
    // 邀请cqs判定
    onCqsConfirm() {
      if (this.idList.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      // 是否显示邀请CQS协助判定按钮
      for (let i = 0; i < this.multipleSelection.length; i++) {
        //FSC
        if (this.multipleSelection[i].status != 'SUBMITTED' || this.multipleSelection[i].fscFeedbackStatus != 'TO_BE_FSC_ISSUED') {
          let errorStr = "页面勾选存在“待FSC反馈状态”不为待FSC反馈的单据，无法邀请CQS协助判定";
          this.$message.warning(errorStr)
          return false
        }
        console.log(this.multipleSelection[i].cqsProcessingMode)
        if (this.multipleSelection[i].cqsProcessingMode) {
          let errorStr = "页面勾选存在CQS已反馈的单据，无法邀请CQS协助判定";
          this.$message.warning(errorStr)
          return false
        }
        // 当前FSC是否具有DC权限
        if (!this.multipleSelection[i].isDcCodeAuth) {
          let errorStr = "页面勾选存在没有“DC编号”操作权限的单据，无法邀请CQS协助判定";
          this.$message.warning(errorStr)
          return false
        }
      }
      this.dialogTit = 'CQS';
      this.dialogReVisable = true;
    },
    sendReq(type) {
      const h = this.$createElement
      var arr = []
      for (let i = 0; i < this.multipleSelection.length; i++) {
        const ele = this.multipleSelection[i];
        // 非SQMS时,如果指标类型为SWA不校验必填，其他指标类型等级必填、如果未填写，提示“请填写2021-01 Potato Facility1 的等级。”
        if (!ele.month) {
          arr.push('请填写 ' + ele.qipCode + '-' + ele.eightBitCode + '-' + ele.productionDate + ' 的QIP事件的评价月')
        }
        if (!ele.qipCode) {
          arr.push('请填写 ' + ele.qipCode + '-' + ele.eightBitCode + '-' + ele.productionDate + ' 的QIP事件的QIP单据编号')
        }
        if (!ele.causeOfNonconformity) {
          arr.push('请填写 ' + ele.qipCode + '-' + ele.eightBitCode + '-' + ele.productionDate + ' 的QIP事件的不合格原因')
        }
        if (!ele.quantity) {
          arr.push('请填写 ' + ele.qipCode + '-' + ele.eightBitCode + '-' + ele.productionDate + ' 的QIP事件的问题产品数量')
        }
        if (!ele.responsibleParty) {
          arr.push('请填写 ' + ele.qipCode + '-' + ele.eightBitCode + '-' + ele.productionDate + ' 的QIP事件的责任方')
        }
        if (type !== 'SUBMIT' && ele.responsibleParty === '承运商' && !ele.carrierCode) {
          arr.push('请填写 ' + ele.qipCode + '-' + ele.eightBitCode + '-' + ele.productionDate + ' 的QIP事件的承运商')
        }
        if (!ele.qipDate) {
          arr.push('请填写 ' + ele.qipCode + '-' + ele.eightBitCode + '-' + ele.productionDate + ' 的QIP事件的QIP日期')
        }
        if (!ele.eightBitCode) {
          arr.push('请填写 ' + ele.qipCode + '-' + ele.eightBitCode + '-' + ele.productionDate + ' 的QIP事件的产品编号')
        }
        if (!ele.discoveryLink) {
          arr.push('请填写 ' + ele.qipCode + '-' + ele.eightBitCode + '-' + ele.productionDate + ' 的QIP事件的发现环节')
        }
        if (!ele.processingMode) {
          arr.push('请填写 ' + ele.qipCode + '-' + ele.eightBitCode + '-' + ele.productionDate + ' 的QIP事件的处理方式')
        }
        if (!ele.dcCode) {
          arr.push('请填写 ' + ele.qipCode + '-' + ele.eightBitCode + '-' + ele.productionDate + ' 的QIP事件的DC编号')
        }
        if (!ele.approver) {
          arr.push('请填写 ' + ele.qipCode + '-' + ele.eightBitCode + '-' + ele.productionDate + ' 的QIP事件的批准方')
        }
        if (!ele.cqsSpecialApprover) {
          arr.push('请填写 ' + ele.qipCode + '-' + ele.eightBitCode + '-' + ele.productionDate + ' 的QIP事件的允收期CQS特批')
        }
      }
      console.log('arr', arr);
      var valid = this.utils.validTable(arr, h)
      if (!valid) {
        return false
      }
      if (type === 'CANCEL') {
        this.$confirm('请确认是否作废选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'colorBtn',
          cancelButtonClass: 'btn_custom_cancel',
          type: 'warning'
        }).then(() => {
          QIPApi.updateBatchQipStatus({
            idList: this.idList,
            type: type
          }).then(res => {
            console.log('提交数据', res);
            if (res.meta.code === 200) {
              this.$message.success('操作成功')
              this.idList = []
              this.$refs['plxTable'].clearSelection()
              this.queryData()
            }
          });
        })
      } else {
        QIPApi.updateBatchQipStatus({
          idList: this.idList,
          type: type
        }).then(res => {
          console.log('提交数据', res);
          if (res.meta.code === 200) {
            this.$message.success('操作成功')
            this.idList = []
            this.$refs['plxTable'].clearSelection()
            this.queryData()
          }
        });
      }
    },
    onExport() {
      this.$set(this.queryCondition, 'idList', this.idList)
      QIPApi.dqmpDownload(this.queryCondition).then(res => {
        fileService.respToFile(res, 'QSPI_QIP_Report.xlsx');
        this.idList = []
        this.$refs['plxTable'].clearSelection()
      });
    },
    onCloseObject() {
      this.dialogObjectVisible = false
      this.queryData()
    },
    onClose() {
      this.dialogBatchVisible = false
      this.queryData()
    },
    onCloseReject() {
      this.dialogReVisable = false;
      this.queryData()
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    onDetail(row) {
      this.$router.push({
        path: '/qspiQIP/detail',
        query: {
          ttQspiQipId: row.ttQspiQipId,
          from: 'edit'
        }
      })
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        monthList: [],
        qipCode: "",
        supplierName: "",
        eightBitCodeName: "",
        category2CodeList: [],
        causeOfNonconformityList: [],
        minQuantity: "",
        maxQuantity: "",
        mcdBuyingUnit: "",
        responsiblePartyList: [],
        carrierCode: "",
        feedbackResults: "",
        statusList: [],
        fscFeedbackStatus: "",
        dcCodeList: [],
      }
      this.idList = []
      this.$refs['plxTable'].clearSelection()
      this.queryData();
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
